<template>
  <v-app>
    <flash-messages />
    <v-main>
      <v-container
        fluid
        fill-height
      >
        <div
          class="justify-center d-flex flex-column align-center"
          style="width: 100%; max-width: 100%;"
        >
          <div style="width: 500px; max-width: 100%;">
            <div class="mb-2">
              <div class="text-center">
                <img
                  src="/assets/logo/wc_s_logo_dark.svg"
                  style="width: 160px"
                  class="mb-2"
                >
                <p class="mb-0 text-h6 font-weight-bold">
                  {{ title }}
                </p>
                <p class="mb-4 text-body-1">
                  <slot name="subtitle" />
                </p>
              </div>

              <portal-target name="flash" />
            </div>

            <div class="text-center mb-4">
              <locales-menu class="float-right">
                <template #activator="{ on, attrs, loading }">
                  <v-btn
                    small
                    color="primary"
                    :loading="loading"
                    :disabled="loading"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>
                      mdi-earth
                    </v-icon>
                    {{ $page.props.app_locales.current.name }}
                    <v-icon right>
                      mdi-chevron-down
                    </v-icon>
                  </v-btn>
                </template>
              </locales-menu>
            </div>

            <slot />
          </div>
          <slot name="bottom" />
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>